import { useCallback } from 'react';
import { useWebSocketMessage } from './useWebSocket';

export interface ProcessingUpdateData {
  fileId: string;
  status: 'unprocessed' | 'processing' | 'completed' | 'failed';
  progress?: {
    processedPages?: number;
    totalPages?: number;
  };
  errorMessage?: string;
  timestamp: string;
}

export function useWebSocketProcessing(
  onProcessingUpdate: (data: ProcessingUpdateData) => void
): void {
  useWebSocketMessage('processing.updated', (data: ProcessingUpdateData) => {
    console.log('[WebSocketProcessing] Received processing update:', data);
    onProcessingUpdate(data);
  });
}